export default __webpack_public_path__ + "smoke.png?5b5975cfd760915f3b744634de5b97b6";